import React, { useEffect, useState } from "react";
import axios from "axios";
import Banner from "molecules/banner";
import { LuLoader } from "react-icons/lu";
import { Icon } from "organisms/iconCommonent";

interface BannerData {
  heading: string;
  localVideo: string | null;
}

interface ApiResponse {
  status: string;
  message: BannerData[];
}

const HomeBanner: React.FC = () => {
  const [bannerData, setBannerData] = useState<BannerData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await axios.get<ApiResponse>("https://api.thebuddhainstitute.org/api/social-changes");
        if (response.data.status === "success" && response.data.message.length > 0) {
          setBannerData(response.data.message[0]);
        }
      } catch (error) {
        console.error("Error fetching banner data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanner();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[400px]">
        <Icon icon={LuLoader} className="animate-spin text-4xl" />
      </div>
    );
  }

  const videoSrc = bannerData?.localVideo?.trim()
    ? `${process.env.REACT_APP_LOCAL_URL}/${bannerData.localVideo.replace(/\\/g, "/")}`
    : "";

  return videoSrc ? (
    <Banner
      videoSrc={videoSrc}
      mainHeading={bannerData?.heading || ""}
      overlayVideo="bg-black/50 absolute inset-0 sm:block hidden"
      subHeading=""
    />
  ) : null;
};

export default HomeBanner;
